module.exports = __webpack_public_path__ + "static/media/medicine.29a09e5e.svg";